var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner"},[_c('v-row',{staticClass:"mt-2 mb-2"},[_c('v-col',{attrs:{"cols":"12","md":"12","align":"center"}},[_c('b-spinner',{attrs:{"variant":"primary","type":"grow"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }